/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskRubricV2Output } from './taskRubricV2Output';
import type { TaskRubricV1 } from './taskRubricV1';

/**
 * Rubric for a task, fits multiple versions
 */
export type TaskRubricOutput = TaskRubricV2Output | TaskRubricV1;
